import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si tengo más de 50 años?',
    a: '¡Absolutamente! Nuestros resultados más impresionantes son de mujeres de 45-55 años.'
  }, {
    q: '¿Necesito ingredientes especiales o costosos?',
    a: 'No. La base del protocolo se arma con ingredientes de supermercado: huevos, carnes/pescado accesibles, verduras de estación, legumbres, arroz/quinoa según fase, yogur natural y semillas. Además, incluimos una Guía de Compras Argentina (versión económica + sustituciones) para que lo adaptes a tu presupuesto.'
  }, {
    q: '¿Tengo que hacer ejercicio extremo?',
    a: 'Solo 15-25 minutos de ejercicios restaurativos. Nada de gym ni equipos costosos.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Garantía de 30 días. Si H.E.R. no es para vos, te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿Funciona si estoy en menopausia?',
    a: 'Especialmente efectivo durante pre/menopausia. Está diseñado para esta etapa.'
  }, {
    q: '¿Es seguro si tengo condiciones médicas?',
    a: 'Es un protocolo natural, pero siempre consulta con tu médico primero.'
  }];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8" data-id="element-55">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-56">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-57">
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-58">
            Preguntas <span className="text-gradient-gold" data-id="element-59">Frecuentes</span>
          </h2>
        </motion.div>

        {/* Accordions */}
        <div className="space-y-4" data-id="element-60">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} index={i} data-id="element-61" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  faq,
  index
}: {
  faq: {
    q: string;
    a: string;
  };
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="card-premium overflow-hidden" data-id="element-62">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-white/[0.02] transition-colors" data-id="element-63">
        <span className="font-body font-semibold text-base md:text-lg text-foreground flex items-start md:items-center gap-3 leading-snug" data-id="element-64">
          <span className="text-xl mt-0.5 md:mt-0" data-id="element-65">❓</span> {faq.q}
        </span>
        <span className="text-secondary flex-shrink-0 ml-4" data-id="element-66">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-67" /> : <PlusIcon className="w-6 h-6" data-id="element-68" />}
        </span>
      </button>

      <AnimatePresence data-id="element-69">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-70">
            <div className="px-5 md:px-6 pb-6 pt-2 text-foreground/80 font-body text-[15px] md:text-base font-medium flex items-start gap-3 border-t border-border/50 mt-2 leading-relaxed" data-id="element-71">
              <span className="text-xl mt-1" data-id="element-72">✅</span>
              <p className="pt-1" data-id="element-73">{faq.a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}